import { useSelector } from "react-redux";
import { IStoreState } from "../redux";

export const useRecordCounts = () => {
  return useSelector(
    (storeState: IStoreState) => storeState.common.recordCounts,
  );
};
